import {
  Component,
  AfterViewInit,
  ChangeDetectorRef,
  OnInit,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HttpErrorResponse } from "@angular/common/http";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { NgxSpinnerService } from "ngx-spinner";
import { map } from "rxjs/operators";
import { Observable } from "rxjs";
import * as global from "../../services/global.service";
import toastr from "toastr";
import { AuthenticationService } from "../../services/authentication.service";
import { IdiomaService } from "../../services/idioma.service";
import { CustomerService } from "../../services/customers.service";
import { DestinationService } from "../../services/destination.service";
import { UserService } from "../../services/user.service";
import { NotificationService } from "../../services/notification.service";
import { SaldosService } from "../../v2/saldos/services/saldos.service";
import { IdiomaRequest } from "../../interfaces/idiomaRequest.model";
import { Idioma } from "../../models/idioma";
import { User } from "../../models/user";
import { Saldo } from "../../models/saldo";

@Component({
  selector: "app-navigation",
  templateUrl: "./navigation.component.html",
  styleUrls: ["./navigation.component.scss"],
})
export class NavigationComponent implements AfterViewInit, OnInit {
  private modalRef: NgbModalRef;
  private modalConf: NgbModalRef;

  public formCustomers: FormGroup;
  public isRed = true;
  public idiomas: Array<Idioma>;
  public config: PerfectScrollbarConfigInterface = {};
  public name: string;
  public user: User;
  public showPassword: false;
  public showConfirm: false;
  public levelPass = 0;
  public emailError = false;
  public nameError = false;
  public pasError = false;
  public updateProcess = false;
  public inputTypePassword: string;
  public inputTypeConfirm: string;
  public step_wizard: any;
  public formEditUser: FormGroup;
  public formType: FormGroup;
  public total_qr = 2;
  public total_app = 2;
  public confirm_title = "";
  public confirm_text = "";
  public isVersionPrueba = false;
  public idiomasCliente = false;
  public api_url: string;
  public activeLang = "es";
  public activeLanguage;
  public idioma: Idioma;
  public nameDefault = "Español";
  public altDEfault = "es";
  public srcDefault = "/imgs/banderas/1563185291.png";
  public showHelpMenuIdioma = false;
  public saldo: Saldo;

  constructor(
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private cdRef: ChangeDetectorRef,
    private translate: TranslateService,
    private spinner: NgxSpinnerService,
    private notificationService: NotificationService,
    private auth: AuthenticationService,
    private idiomaService: IdiomaService,
    private customerService: CustomerService,
    private destinationService: DestinationService,
    private userService: UserService,
    private saldosService: SaldosService
  ) {
    this.user = this.auth.currentUserValue.user;
    this.idiomas = [];
    this.translate.setDefaultLang(this.activeLang);
    this.saldo = {
      clienteId: this.user.cliente.id,
      cantidadGastos: 0,
      cantidadIngreso: 0,
      saldoFinal: 0,
      saldoInicial: 0,
    };

    if (this.user && !this.user.wizard) {
      if (
        window.location.href.includes("panel.unblockthecity.com") ||
        window.location.href.includes("oldadmin.unblockthecity.com") ||
        window.location.href.includes("localhost")
      ) {
        this.isRed = true;
      } else {
        this.isRed = false;
      }

      this.idiomaService
        .index()
        .pipe(
          map((response: any) => {
            return response.data;
          })
        )
        .toPromise()
        .then(
          (idiomas: Array<Idioma>) => {
            this.idiomas = idiomas;
          },
          (error: HttpErrorResponse) => {
            console.log(error);
          }
        );

      this.saldosService
        .today()
        .toPromise()
        .then(
          (saldo: Saldo) => {
            this.saldo = saldo;
          },
          (error: HttpErrorResponse) => {
            if (error.status != 404) {
              this.notificationService.error(
                this.translate.instant("No se pudo obtener el saldo")
              );
            }
          }
        );
    }
  }

  showHelp() {
    this.showHelpMenuIdioma = !this.showHelpMenuIdioma;
  }

  public cambiarIdioma(lang) {
    this.activeLang = lang;
    this.translate.use(lang);

    if (this.idiomas[0].codigo === "es") {
      lang = "es";
    }
    if (this.idiomas[0].codigo === "en") {
      lang = "en";
    }
    if (this.idiomas[0].codigo === "ca") {
      lang = "ca";
    }
    if (this.idiomas[0].codigo === "gl") {
      lang = "gl";
    }
    if (this.idiomas[0].codigo === "fr") {
      lang = "fr";
    }
  }

  public changecode(item: any) {
    this.srcDefault = item.bandera;
    this.nameDefault = item.nombre;
  }

  fillTable() {
    this.spinner.show();
    const idiomaRequest: IdiomaRequest = new IdiomaRequest();
    idiomaRequest.setOrderBy("ASC");
    this.idiomaService
      .index(idiomaRequest)
      .toPromise()
      .then(
        (pagination: any) => {
          this.idiomas = pagination.data;
          this.spinner.hide();
        },
        (error: HttpErrorResponse) => {
          this.spinner.hide();
          console.log(error);
        }
      );
  }

  ngOnInit() {
    this.fillTable();
    this.api_url = global.API_URL;

    if (this.user.cupon) {
      this.total_app = this.user.cupon.numApp;
      this.total_qr = this.user.cupon.numQr;
    }

    if (this.isLocalhostOrPanel(location.hostname)) {
      this.isVersionPrueba = true;
    }

    this.formEditUser = this.formBuilder.group({
      name: ["", Validators.required],
      email: ["", [Validators.required, Validators.email]],
      password: [""],
      confirm: [""],
    });

    this.formCustomers = this.formBuilder.group({
      nombre: ["", Validators.required],
      direccion: ["", Validators.required],
      ciudad: ["", Validators.required],
      telefono: ["", Validators.required],
      email: ["", [Validators.required, Validators.email]],
      contacto: [""],
      cif: [""],
      idiomaId: [null, Validators.required],
    });

    this.formType = this.formBuilder.group({
      codigo: [""],
    });

    this.inputTypePassword = "password";
    this.inputTypeConfirm = "password";
  }

  ngAfterViewInit() {
    this.formEditUser.patchValue(this.user);
    this.formEditUser.patchValue({ password: "" });

    this.cdRef.detectChanges();

    const set = function () {
      const width =
        window.innerWidth > 0 ? window.innerWidth : this.screen.width;
      const topOffset = 0;
      if (width < 1170) {
        $("#main-wrapper").addClass("mini-sidebar");
      } else {
        $("#main-wrapper").removeClass("mini-sidebar");
      }
    };

    $(window).ready(set);
    $(window).on("resize", set);

    $(".search-box a, .search-box .app-search .srh-btn").on(
      "click",
      function () {
        $(".app-search").toggle(200);
      }
    );
    $("#sidebarnav li a:not(.has_child)").on("click", function () {
      $(".left-sidebar").removeClass("visible");
    });
    $("body").trigger("resize");
  }

  isLocalhostOrPanel(url) {
    return (
      url.includes("localhost") ||
      url.includes("127.0.0.1") ||
      url.includes("panel.unblockthecity.com")
    );
  }

  clickMenu($event) {
    if ($(".left-sidebar").hasClass("visible")) {
      $(".left-sidebar").removeClass("visible");
    } else {
      $(".left-sidebar").addClass("visible");
    }
    event.stopPropagation();
  }

  closeMenu() {
    if ($(".left-sidebar").hasClass("visible")) {
      $(".left-sidebar").removeClass("visible");
    }
  }

  logout() {
    this.auth.logout();
  }

  public open(content): void {
    if (this.auth.currentCustomerValue || this.auth.currentAdminValue) {
      this.formEditUser.patchValue({ password: "" });

      let request: Observable<Object>;

      if (this.auth.currentCustomerValue) {
        request = this.customerService.show(this.auth.currentCustomerValue.id);
      } else {
        request = this.destinationService.show(this.auth.currentAdminValue.id);
      }

      request.subscribe((response: any) => {
        this.formCustomers.patchValue({
          nombre: response.nombre,
          direccion: response.direccion,
          ciudad: response.ciudad,
          telefono: response.telefono,
          email: response.email,
          contacto: response.contacto,
          cif: response.cif,
          idiomaId: response.idiomaId,
        });

        this.modalRef = this.modalService.open(content, {
          centered: true,
          windowClass: "newModal",
          backdrop: "static",
          keyboard: false,
        });
      });
    }
  }

  clearContent(input: string) {
    this.formEditUser.get(input).reset();
  }

  abrirModalConfirm(modal) {
    this.modalConf = this.modalService.open(modal, {
      centered: true,
      windowClass: "newModal",
      backdrop: "static",
      keyboard: false,
    });
  }

  cerrarModalConfirm() {
    this.modalConf.close();
  }

  showPasswordToggle(info: any) {
    this.showPassword = info;

    if (this.showPassword) {
      this.inputTypePassword = "text";
    } else {
      this.inputTypePassword = "password";
    }
  }

  showConfirmToggle(info: any) {
    this.showConfirm = info;

    if (this.showConfirm) {
      this.inputTypeConfirm = "text";
    } else {
      this.inputTypeConfirm = "password";
    }
  }

  onInputPass(value) {
    let cont = 0;

    if (value.length === 0) {
      this.levelPass = 0;
      return;
    }

    if (value.length > 7) {
      cont++;
    }

    const matches = value.match(/\d+/g);
    if (matches != null) {
      cont++;
    }

    if (/[A-Z]/.test(value)) {
      cont++;
    }

    if (cont === 0) {
      cont++;
    }
    this.levelPass = cont;
  }

  saveCoupon() {
    const user: User = this.user;

    user.codigo = this.formType.get("codigo").value;

    this.userService.update(user).subscribe((data: any) => {
      if (data.error && data.error === 1) {
        toastr.error(null, data.mensaje, { positionClass: "toast-top-center" });
      } else {
        this.auth.updateUser(data.user);
        this.total_app = this.user.cupon.numApp;
        this.total_qr = this.user.cupon.numQr;
        this.formType.reset();
        toastr.success(null, "Codigo cupon actualizado", {
          positionClass: "toast-top-center",
        });
      }
      this.cerrarModalConfirm();
      this.modalRef.dismiss();
    });
  }

  newCoupon(formValue, modal) {
    if (formValue.codigo !== "") {
      this.confirm_title = this.translate.instant("Cupon descuento");
      // tslint:disable-next-line: max-line-length
      this.confirm_text = this.translate.instant(
        "¿Quieres asignar el cupón descuento a tu cuenta de usuario?, Cualquier cupón previo quedara sustituido por el nuevo."
      );
      this.abrirModalConfirm(modal);
    } else {
      this.modalRef.dismiss();
    }
  }

  public editCustomers(formValue: any): void {
    if (this.formCustomers.valid) {
      this.customerService.update(formValue).subscribe(
        (data) => {
          toastr.success(null, "Cliente actualizado correctamente", {
            positionClass: "toast-top-center",
          });

          this.modalRef.close();

          this.customerService.byUserId(this.user.id).subscribe((data: any) => {
            if (data.cliente) {
              this.auth.updateCustomer(data.cliente);
            }
          });
        },
        (error) => {
          toastr.error(
            null,
            "No se han editado los datos de cliente, vuelva a intentarlo",
            { positionClass: "toast-top-center" }
          );
        }
      );
    }
  }

  editUser(formValue: any) {
    this.pasError = false;
    this.emailError = false;
    this.nameError = false;

    if (!this.formEditUser.valid) {
      if (formValue.name !== "") {
        this.emailError = true;
        this.nameError = false;
      } else {
        this.emailError = true;
        this.nameError = true;
      }
    } else {
      if (formValue.password !== "") {
        if (this.levelPass >= 3) {
          if (formValue.password !== formValue.confirm) {
            this.pasError = true;
            this.updateProcess = false;
          } else {
            this.pasError = false;
            this.updateProcess = true;
          }
        } else {
          this.pasError = true;
          this.updateProcess = false;
        }
      } else {
        this.updateProcess = true;
      }
    }

    if (this.updateProcess) {
      const user: User = this.user;

      user.name = formValue.name;
      user.email = formValue.email;
      user.password = formValue.password;

      this.userService.update(user).subscribe(
        (data: User) => {
          if (formValue.password === "") {
            this.auth.updateUser({ ...this.auth.currentUserValue, user: data });
            this.user = this.auth.currentUserValue;
            this.modalRef.close();
            this.formEditUser.patchValue({ password: "" });
            this.formEditUser.patchValue({ confirm: "" });
          }

          toastr.success(null, "Usuario actualizado con exito", {
            positionClass: "toast-top-center",
          });

          if (formValue.password !== "") {
            this.auth.logout();
          }
        },
        (error) => {
          toastr.error(
            null,
            "No se ha editado el usuario, vuelva a intentarlo",
            { positionClass: "toast-top-center" }
          );
        }
      );
    }
  }
}
